(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function getI18n(el) {
    try {
      return JSON.parse(el.dataset.i18n || '{}');
    } catch (_) {
      return {};
    }
  }

  function t(dict, key, fallback = '') {
    return key.split('.').reduce((acc, part) => (acc && acc[part] != null ? acc[part] : null), dict) ?? fallback;
  }

  function tf(str, vars = {}) {
    return String(str || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => vars[k] ?? '');
  }

  // -------------------------
  // Inline SVG icons (no .liquid needed)
  // -------------------------
  const ICON_UPLOAD = `
    <svg width="25" height="25" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M7.88533 21.9495C7.34789 21.9495 6.8995 21.7698 6.54017 21.4105C6.18083 21.0512 6.00078 20.6024 6 20.0642V17.8207C6 17.655 6.05561 17.5166 6.16683 17.4053C6.27806 17.2941 6.41689 17.2381 6.58333 17.2373C6.74978 17.2366 6.88861 17.2926 6.99983 17.4053C7.11106 17.5181 7.16667 17.6566 7.16667 17.8207V20.0642C7.16667 20.2438 7.24133 20.4087 7.39067 20.5588C7.54 20.7089 7.7045 20.7836 7.88417 20.7828H20.4492C20.6281 20.7828 20.7926 20.7082 20.9427 20.5588C21.0928 20.4095 21.1674 20.2446 21.1667 20.0642V17.8207C21.1667 17.655 21.2223 17.5166 21.3335 17.4053C21.4447 17.2941 21.5836 17.2381 21.75 17.2373C21.9164 17.2366 22.0553 17.2926 22.1665 17.4053C22.2777 17.5181 22.3333 17.6566 22.3333 17.8207V20.0642C22.3333 20.6016 22.1537 21.05 21.7943 21.4093C21.435 21.7687 20.9862 21.9487 20.448 21.9495H7.88533ZM13.5833 7.86433L11.2838 10.1638C11.1703 10.2774 11.0353 10.3369 10.879 10.3423C10.7227 10.3478 10.5803 10.2859 10.452 10.1568C10.3276 10.0285 10.2642 9.89122 10.2618 9.745C10.2595 9.598 10.3229 9.46033 10.452 9.332L13.5063 6.27533C13.609 6.17422 13.7132 6.10306 13.819 6.06183C13.9256 6.02061 14.0414 6 14.1667 6C14.2919 6 14.4078 6.02061 14.5143 6.06183C14.6209 6.10306 14.7251 6.17461 14.827 6.2765L17.8813 9.332C17.9957 9.44556 18.0556 9.57933 18.061 9.73333C18.0657 9.88733 18.0062 10.0285 17.8825 10.1568C17.7534 10.2859 17.6146 10.3517 17.466 10.354C17.3174 10.3563 17.1786 10.2929 17.0495 10.1638L14.75 7.86433V17.3727C14.75 17.5391 14.6944 17.6779 14.5832 17.7892C14.4719 17.9004 14.3331 17.956 14.1667 17.956C14.0002 17.956 13.8614 17.9004 13.7502 17.7892C13.6389 17.6779 13.5833 17.5391 13.5833 17.3727V7.86433Z" fill="currentColor"/>
    </svg>
  `;

  const ICON_BACK = `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M1.5 8C1.5 11.5897 4.41031 14.5 8 14.5C11.5897 14.5 14.5 11.5897 14.5 8C14.5 4.41031 11.5897 1.5 8 1.5C4.41031 1.5 1.5 4.41031 1.5 8ZM8.5 5.49719L6.51312 7.5H11.1875V8.5H6.51312L8.5 10.5028L7.79063 11.2072L4.60813 8L7.79063 4.79281L8.5 5.49719Z" fill="currentColor"/>
    </svg>
  `;

  const ICON_REMOVE = `
    <svg width="16" height="16" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M4.00065 11.875C4.00065 12.2065 4.14113 12.5245 4.39118 12.7589C4.64122 12.9933 4.98036 13.125 5.33398 13.125H10.6673C11.0209 13.125 11.3601 12.9933 11.6101 12.7589C11.8602 12.5245 12.0007 12.2065 12.0007 11.875V4.375H4.00065V11.875ZM5.33398 5.625H10.6673V11.875H5.33398V5.625ZM10.334 2.5L9.66732 1.875H6.33398L5.66732 2.5H3.33398V3.75H12.6673V2.5H10.334Z" fill="currentColor"/>
    </svg>
  `;

  const ICON_STATUS_OK = `
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M9.11259 5.44569C9.19608 5.35925 9.24227 5.24347 9.24123 5.1233C9.24019 5.00312 9.19198 4.88817 9.107 4.80319C9.02203 4.71821 8.90707 4.67001 8.7869 4.66896C8.66672 4.66792 8.55095 4.71412 8.4645 4.7976L6.03534 7.22677L4.52284 5.71427C4.43639 5.63078 4.32062 5.58459 4.20044 5.58563C4.08027 5.58667 3.96532 5.63488 3.88034 5.71985C3.79536 5.80483 3.74716 5.91979 3.74611 6.03996C3.74507 6.16014 3.79126 6.27591 3.87475 6.36235L5.70809 8.19569C5.79404 8.28161 5.91059 8.32988 6.03213 8.32988C6.15366 8.32988 6.27022 8.28161 6.35617 8.19569L9.10617 5.44569H9.11259Z" fill="#418944"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.5C12 9.53417 9.53417 12 6.5 12C3.46583 12 1 9.53417 1 6.5C1 3.46583 3.46583 1 6.5 1C9.53417 1 12 3.46583 12 6.5ZM11.0833 6.5C11.0833 9.03 9.03 11.0833 6.5 11.0833C3.97 11.0833 1.91667 9.03 1.91667 6.5C1.91667 3.97 3.97 1.91667 6.5 1.91667C9.03 1.91667 11.0833 3.97 11.0833 6.5Z" fill="#418944"/>
    </svg>
  `;

  const ICON_STATUS_ERR = `
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M6.50065 9.20801C6.65412 9.20801 6.78286 9.15601 6.88686 9.05201C6.99086 8.94801 7.04268 8.81945 7.04232 8.66634C7.04196 8.51323 6.98996 8.38467 6.88632 8.28067C6.78268 8.17667 6.65412 8.12467 6.50065 8.12467C6.34718 8.12467 6.21862 8.17667 6.11499 8.28067C6.01135 8.38467 5.95935 8.51323 5.95899 8.66634C5.95862 8.81945 6.01062 8.94819 6.11499 9.05255C6.21935 9.15691 6.3479 9.20873 6.50065 9.20801ZM5.95899 7.04134H7.04232V3.79134H5.95899V7.04134ZM6.50065 11.9163C5.75135 11.9163 5.04718 11.7741 4.38815 11.4895C3.72912 11.205 3.15586 10.8191 2.66836 10.332C2.18086 9.84483 1.79501 9.27156 1.51082 8.61217C1.22662 7.95278 1.08435 7.24862 1.08399 6.49967C1.08362 5.75073 1.2259 5.04656 1.51082 4.38717C1.79574 3.72779 2.18158 3.15452 2.66836 2.66738C3.15514 2.18024 3.7284 1.7944 4.38815 1.50984C5.0479 1.22529 5.75207 1.08301 6.50065 1.08301C7.24924 1.08301 7.9534 1.22529 8.61315 1.50984C9.2729 1.7944 9.84617 2.18024 10.3329 2.66738C10.8197 3.15452 11.2057 3.72779 11.491 4.38717C11.7763 5.04656 11.9184 5.75073 11.9173 6.49967C11.9162 7.24862 11.774 7.95278 11.4905 8.61217C11.207 9.27156 10.8212 9.84483 10.3329 10.332C9.84472 10.8191 9.27146 11.2051 8.61315 11.49C7.95485 11.775 7.25068 11.9171 6.50065 11.9163ZM6.50065 10.833C7.71037 10.833 8.73503 10.4132 9.57461 9.57363C10.4142 8.73405 10.834 7.7094 10.834 6.49967C10.834 5.28995 10.4142 4.2653 9.57461 3.42572C8.73503 2.58613 7.71037 2.16634 6.50065 2.16634C5.29093 2.16634 4.26628 2.58613 3.42669 3.42572C2.58711 4.2653 2.16732 5.28995 2.16732 6.49967C2.16732 7.7094 2.58711 8.73405 3.42669 9.57363C4.26628 10.4132 5.29093 10.833 6.50065 10.833Z" fill="#A82B38"/>
    </svg>
  `;

  function buildReasons(i18n) {
    return [
      { value: 'item_too_small', label: t(i18n, 'reasons.item_too_small', 'Item too small') },
      { value: 'item_too_large', label: t(i18n, 'reasons.item_too_large', 'Item too large') },
      { value: 'not_as_described', label: t(i18n, 'reasons.not_as_described', 'Item not as described') },
      { value: 'arrived_late', label: t(i18n, 'reasons.arrived_late', 'Item arrived late') },
      { value: 'change_of_mind', label: t(i18n, 'reasons.change_of_mind', 'Change of mind') },
      { value: 'ordered_wrong_item', label: t(i18n, 'reasons.ordered_wrong_item_or_size', 'Ordered wrong item') },
      { value: 'damaged_or_defective', label: t(i18n, 'reasons.damaged_or_defective', 'Damaged or defective item') },
      { value: 'others', label: t(i18n, 'reasons.others', 'Others (Please specify)') }
    ];
  }

  function qs(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
  }

  function formatPrice(it, order) {
    const s = it.priceFormatted || it.formattedPrice || it.displayPrice || '';
    if (s) return s;

    const amount =
      it.priceAmount ??
      it.unitPriceAmount ??
      it.price ??
      it.unitPrice ??
      it.finalPrice ??
      null;

    const currency =
      it.currency ||
      it.currencyCode ||
      order?.currency ||
      order?.currencyCode ||
      '';

    if (amount == null || amount === '') return '';

    const n = Number(amount);
    if (!Number.isFinite(n)) return `${amount}${currency ? ` ${currency}` : ''}`;

    return `${currency ? `${currency} ` : ''}${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  function escapeHtml(s) {
    return String(s)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function setBusy(btn, busy, i18n = {}) {
    if (!btn) return;
    btn.disabled = !!busy;
    btn.dataset._label ??= btn.textContent;
    btn.textContent = busy ? t(i18n, 'please_wait', 'PLEASE WAIT…') : btn.dataset._label;
  }

  function ensureApiBaseUrl(apiBaseUrl) {
    const v = String(apiBaseUrl || '').trim();
    if (!v || v.includes('YOUR_API_GATEWAY_BASE_URL')) {
      throw new Error('API base URL is not configured. Please update data-api-base-url in the section.');
    }
    return v.replace(/\/$/, '');
  }

  function getCustomerLocale() {
    return (
      document.documentElement.lang ||
      (window.Shopify && window.Shopify.locale) ||
      navigator.language ||
      ''
    );
  }

  async function apiFetch(apiBaseUrl, path, opts = {}) {
    const base = ensureApiBaseUrl(apiBaseUrl);
    const url = base + path;

    const method = (opts.method || 'GET').toUpperCase();
    const headers = { ...(opts.headers || {}) };
    const hasBody = opts.body != null && method !== 'GET' && method !== 'HEAD';
    if (hasBody && !headers['Content-Type']) headers['Content-Type'] = 'application/json';

    const res = await fetch(url, {
      mode: 'cors',
      ...opts,
      method,
      headers,
    });

    const text = await res.text();
    let json = null;
    try { json = text ? JSON.parse(text) : null; } catch (_) {}

    if (!res.ok) {
      const msg = (json && (json.error || json.message)) || text || `HTTP ${res.status}`;
      throw new Error(msg);
    }
    return json;
  }

  function renderStepper(step) {
    const cur = Number(step) || 1;
    const cls = (n) => [
      'rr-dot',
      cur === n ? 'is-active' : '',
      cur > n ? 'is-complete' : '',
    ].filter(Boolean).join(' ');

    return `
      <div class="rr-stepper is-step-${cur}" aria-hidden="true">
        <span class="${cls(1)}"></span>
        <span class="${cls(2)}"></span>
        <span class="${cls(3)}"></span>
      </div>
    `;
  }

  function getItemEligibleFlag(item) {
    const e = item.eligibility || item.returnEligibility || null;
    if (typeof item.eligible === 'boolean') return item.eligible;
    if (typeof item.isEligible === 'boolean') return item.isEligible;
    if (e && typeof e.eligible === 'boolean') return e.eligible;
    if (e && typeof e.overallEligible === 'boolean') return e.overallEligible;
    return null;
  }

  function getIneligibleMessage(policyUrl, i18n) {
    const safeUrl = escapeHtml(policyUrl || '#');
    return `
      <span class="rr-ico rr-ico-error">${ICON_STATUS_ERR}</span>
      ${tf(t(i18n, 'ineligible_message_html', 'This product is not eligible for return under our <a href="{{policy_url}}" target="_blank" rel="noopener" style="text-decoration:underline;">return policy</a>.<br/>However, you may still submit a request in exceptional cases, such as product defects.'), { policy_url: safeUrl })}
    `;
  }

  function getPolicyMessage(type, policyUrl, i18n) {
    const safeUrl = escapeHtml(policyUrl || '#');
    if (type === 'exchange') return tf(t(i18n, 'policy_exchange_html', ''), { policy_url: safeUrl });
    if (type === 'return') return tf(t(i18n, 'policy_return_html', ''), { policy_url: safeUrl });
    return '';
  }

  function normalizeItem(item) {
    const eligible = getItemEligibleFlag(item);
    return {
      ...item,
      eligible,
      selected: false,
      selectedQty: 1,
      requestType: '',
      reason: '',
      description: '',
      exchangeProduct: '',
      attachments: [],
      pendingFiles: [],
    };
  }

  function scrollToTopSmooth() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function mountVerify(el) {
    const storeKey = el.dataset.storeKey || '';
    const shopDomain = el.dataset.shopDomain || '';
    const apiBaseUrl = el.dataset.apiBaseUrl;
    const requestPageUrl = el.dataset.requestPageUrl;
    const i18n = getI18n(el);

    el.innerHTML = `
      <form class="rr-form" id="rrVerifyForm">
        <div class="rr-field">
          <label class="rr-label">${escapeHtml(t(i18n, 'order_number', 'ORDER NUMBER'))}</label>
          <input class="rr-input" name="orderNumber" placeholder="${escapeHtml(t(i18n, 'enter_order_number', 'Enter order number'))}" autocomplete="off" required />
        </div>
        <div class="rr-field">
          <label class="rr-label">${escapeHtml(t(i18n, 'email_address', 'EMAIL ADDRESS'))}</label>
          <input class="rr-input" type="email" name="email" placeholder="${escapeHtml(t(i18n, 'enter_email_address', 'Enter email address'))}" autocomplete="email" required />
        </div>
        <div class="rr-field" style="margin-top:18px;">
          <button class="rr-btn" type="submit" disabled>${escapeHtml(t(i18n, 'find_order', 'FIND ORDER'))}</button>
        </div>
        <div class="rr-center" id="rrVerifyMsg"></div>
        <p class="contact-link">${t(i18n, 'contact_us_html', 'Any questions? Contact us at <a title="contact us at cs@evisu.com" href="mailto:cs@evisu.com">cs@evisu.com</a>.')}</p>
      </form>
    `;

    const form = $('#rrVerifyForm', el);
    const btn = $('button[type="submit"]', form);
    const msg = $('#rrVerifyMsg', el);

    function refreshDisabled() {
      const orderNumber = form.orderNumber.value.trim();
      const email = form.email.value.trim();
      btn.disabled = !(orderNumber && email);
    }

    form.addEventListener('input', refreshDisabled);
    refreshDisabled();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      msg.innerHTML = '';
      setBusy(btn, true, i18n);

      try {
        const orderNumber = form.orderNumber.value.trim();
        const email = form.email.value.trim();
        const params = new URLSearchParams({
          orderNumber,
          email,
          store: storeKey,
          shop: shopDomain,
          locale: getCustomerLocale(),
        });
        const data = await apiFetch(apiBaseUrl, `/lookup?${params.toString()}`);
        const sessionId = data.sessionId;
        window.location.assign(`${requestPageUrl}?sessionId=${encodeURIComponent(sessionId)}`);
      } catch (err) {
        msg.innerHTML = `<div class="rr-error">${escapeHtml(err.message || t(i18n, 'try_again', 'Please try again.'))}</div>`;
      } finally {
        setBusy(btn, false, i18n);
      }
    });
  }

  function mountRequest(el) {
    const storeKey = el.dataset.storeKey || '';
    const shopDomain = el.dataset.shopDomain || '';
    const apiBaseUrl = el.dataset.apiBaseUrl;
    const homeUrl = el.dataset.homeUrl || '/';
    const policyUrl = el.dataset.policyUrl || '/pages/delivery-and-returns';
    const i18n = getI18n(el);
    const REASONS = buildReasons(i18n);

    const sessionId = qs('sessionId');
    if (!sessionId) {
      el.innerHTML = `<div class="rr-error">${escapeHtml(t(i18n, 'missing_session', 'Missing sessionId. Please go back to the verification page.'))}</div>`;
      return;
    }

    el.innerHTML = `<div class="rr-center">${escapeHtml(t(i18n, 'loading', 'Loading…'))}</div>`;

    (async () => {
      try {
        const params = new URLSearchParams({
          sessionId,
          store: storeKey,
          shop: shopDomain,
          locale: getCustomerLocale(),
        });
        const data = await apiFetch(apiBaseUrl, `/lookup?${params.toString()}`);
        const order = data.order;

        let items = (order.items || []).map(normalizeItem);
        let step = 1;
        let additionalComments = '';

        const selectedItems = () => items.filter(i => i.selected);
        const canContinueFromSelect = () => selectedItems().length > 0;

        const MAX_FILES = 5;
        const MAX_FILE_BYTES = 10 * 1024 * 1024;
        const ALLOW_TYPES = new Set(['image/png', 'image/jpeg', 'application/pdf']);

        function fmtMB(bytes) {
          return (bytes / (1024 * 1024)).toFixed(2) + 'MB';
        }

        function validateFile(f) {
          if (!ALLOW_TYPES.has(f.type)) {
            return tf(t(i18n, 'unsupported_file_type', 'Unsupported file type ({{type}}).'), { type: f.type || 'unknown' });
          }
          if (f.size > MAX_FILE_BYTES) return t(i18n, 'file_exceeds_size', 'File exceeds 10MB');
          return '';
        }

        function validPending(it) {
          return (it.pendingFiles || []).filter(p => p.valid);
        }
        function validPendingCount(it) {
          return validPending(it).length;
        }

        function canSubmit() {
          const sel = selectedItems();
          if (sel.length === 0) return false;

          for (const it of sel) {
            if (!it.requestType) return false;
            if (!it.reason) return false;
            if (it.requestType === 'exchange' && !(it.exchangeProduct || '').trim()) return false;
            if (it.reason === 'others' && !(it.description || '').trim()) return false;
            if (it.reason === 'damaged_or_defective') {
              const hasValid = (it.attachments?.length || 0) + validPendingCount(it) > 0;
              if (!hasValid) return false;
            }
          }
          return true;
        }

        function findItemByLineId(lineItemId) {
          return items.find(x => x.lineItemId === lineItemId);
        }

        function renderFileLists(card, it) {
          const pendingEl = $('.rr-pending', card);
          const uploadedEl = $('.rr-uploaded', card);
          const inputEl = $('.rr-file', card);

          if (pendingEl) {
            pendingEl.innerHTML = (it.pendingFiles || []).map(p => {
              const statusIcon = p.valid
                ? `<span class="rr-ico rr-ico-ok">${ICON_STATUS_OK}</span>`
                : `<span class="rr-ico rr-ico-error">${ICON_STATUS_ERR}</span>`;
              const err = p.valid ? '' : `<div class="rr-warning rr-file-error">${escapeHtml(p.error)}</div>`;
              return `
                <div class="rr-file-row ${p.valid ? '' : 'rr-file-error'}" data-pending-id="${escapeHtml(p.id)}">
                  <div class="rr-file-left">
                    <div class="rr-file-name">
                      ${statusIcon}
                      ${escapeHtml(p.name)}
                      <span class="rr-file-size">(${fmtMB(p.size)})</span>
                    </div>
                    ${err}
                  </div>
                  <button type="button" class="rr-remove-file" data-pending-id="${escapeHtml(p.id)}">
                    <span class="rr-ico rr-ico-remove">${ICON_REMOVE}</span>
                  </button>
                </div>
              `;
            }).join('');
          }

          if (uploadedEl) {
            uploadedEl.innerHTML = (it.attachments || [])
              .map(a => `<div class="rr-muted" style="text-align:left;">✅ ${escapeHtml(a.name)}</div>`)
              .join('');
          }

          if (inputEl) inputEl.disabled = validPendingCount(it) >= MAX_FILES;
        }

        async function uploadPendingForItem(it) {
          const pending = validPending(it);
          if (pending.length === 0) return;

          for (const p of pending) {
            const f = p.file;
            const presign = await apiFetch(apiBaseUrl, '/create-upload-url', {
              method: 'POST',
              body: JSON.stringify({
                sessionId,
                fileName: f.name,
                contentType: f.type || 'application/octet-stream'
              }),
            });

            await fetch(presign.uploadUrl, {
              method: 'PUT',
              mode: 'cors',
              headers: { 'Content-Type': f.type || 'application/octet-stream' },
              body: f,
            });

            it.attachments.push({
              name: f.name,
              url: presign.fileUrl,
              contentType: f.type,
              size: f.size,
            });
          }

          it.pendingFiles = [];
        }

        function render() {
          if (step === 99) return;

          const header = `
            <div class="rr-center rr-center-subtitle" style="margin-bottom:10px;">
              <div>${escapeHtml(t(i18n, 'order_number_label', 'ORDER NUMBER:'))} <span>${escapeHtml(order.orderNumber || '')}</span></div>
            </div>
          `;

          if (step === 1) {
            el.innerHTML = `
              ${header}
              ${renderStepper(1)}
              <div class="rr-panel">
                <div class="rr-panel-title">${escapeHtml(t(i18n, 'request_details', 'REQUEST DETAILS'))}</div>
                <div class="rr-panel-sub-title">${escapeHtml(t(i18n, 'step_1_title', '1. What would you like to return/ exchange?'))}</div>
                <div id="rrItems"></div>
                <div class="rr-actions" style="justify-content:center;">
                  <button class="rr-btn" id="rrContinue" ${canContinueFromSelect() ? '' : 'disabled'} style="max-width:260px;">${escapeHtml(t(i18n, 'continue', 'CONTINUE'))}</button>
                </div>
              </div>
            `;

            const list = $('#rrItems', el);
            list.innerHTML = items.map((it, idx) => {
              const opts = (it.options || [])
              .slice()
              .sort((a, b) => {
                const ra = String(a?.name || '').trim().toLowerCase();
                const rb = String(b?.name || '').trim().toLowerCase();

                const aIsSize = ra === 'size';
                const bIsSize = rb === 'size';
                if (aIsSize !== bIsSize) return aIsSize ? -1 : 1;

                const aIsColor = ra === 'color';
                const bIsColor = rb === 'color';
                if (aIsColor !== bIsColor) return aIsColor ? -1 : 1;

                return 0;
              })
              .map(o => {
                const rawName = String(o?.name || '').trim().toLowerCase();

                let label = o.name;
                if (rawName === 'size') {
                  label = t(i18n, 'size', 'Size');
                } else if (rawName === 'color') {
                  label = t(i18n, 'color', 'Color');
                }

                return `${label}: ${o.value}`;
              })
              .join(' | ');

              const showIneligible = it.selected && it.eligible === false;
              const ineligibleHtml = `
                <div class="rr-warning rr-eligibility" style="margin-top:8px; display:${showIneligible ? 'block' : 'none'};">
                  ${getIneligibleMessage(policyUrl, i18n)}
                </div>
              `;

              return `
                <div class="rr-item" data-idx="${idx}">
                  <div class="rr-item-head">
                    <label class="rr-label-container">
                      <input type="checkbox" class="rr-item-check" ${it.selected ? 'checked' : ''} />
                      <span class="checkmark"></span>
                    </label>
                    ${it.imageUrl ? `<img class="rr-thumb" src="${escapeHtml(it.imageUrl)}" alt=""/>` : `<div class="rr-thumb" aria-hidden="true"></div>`}
                    <div>
                      <div style="line-height: 20px;">${escapeHtml(it.title || '')}</div>
                      <div class="hide-mobile" style="color: #777777;">${escapeHtml(opts)}</div>
                      <div class="hide-mobile" style="color: #777777;">${escapeHtml(t(i18n, 'sku', 'SKU:'))} ${escapeHtml(it.sku || '')}</div>
                      ${formatPrice(it, order) ? `<div class="hide-mobile" style="color:#777777;">${escapeHtml(t(i18n, 'price', 'Price:'))} ${escapeHtml(formatPrice(it, order))}</div>` : ''}
                    </div>
                    ${ineligibleHtml}
                    <div class="rr-qty-wrap">
                      <div class="hide-desktop">
                        <div style="color: #777777;">${escapeHtml(opts)}</div>
                        <div style="color: #777777;">${escapeHtml(t(i18n, 'sku', 'SKU:'))} ${escapeHtml(it.sku || '')}</div>
                        ${formatPrice(it, order) ? `<div style="color:#777777;">${escapeHtml(t(i18n, 'price', 'Price:'))} ${escapeHtml(formatPrice(it, order))}</div>` : ''}
                      </div>
                      <select class="rr-select rr-qty">
                        ${Array.from({ length: it.quantity || 1 }).map((_, i) => {
                          const q = i + 1;
                          return `<option value="${q}" ${q === it.selectedQty ? 'selected' : ''}>${q}</option>`;
                        }).join('')}
                      </select>
                    </div>
                  </div>
                </div>
              `;
            }).join('');

            list.addEventListener('change', (e) => {
              const row = e.target.closest('.rr-item');
              if (!row) return;
              const idx = Number(row.dataset.idx);
              const it = items[idx];

              if (e.target.classList.contains('rr-item-check')) {
                it.selected = e.target.checked;
              }

              if (e.target.classList.contains('rr-qty')) {
                it.selectedQty = Number(e.target.value);
                if (!it.selected) {
                  it.selected = true;
                  row.querySelector('.rr-item-check').checked = true;
                }
              }

              const warn = $('.rr-eligibility', row);
              if (warn) {
                const show = it.selected && it.eligible === false;
                warn.style.display = show ? 'block' : 'none';
              }

              $('#rrContinue', el).disabled = !canContinueFromSelect();
            });

            $('#rrContinue', el).addEventListener('click', () => {
              if (!canContinueFromSelect()) return;
              $$('.rr-warning.rr-eligibility', el).forEach(w => {
                w.style.display = 'none';
              });
              step = 2;
              render();
              scrollToTopSmooth();
            });

            return;
          }

          if (step === 2) {
            const sel = selectedItems();

            el.innerHTML = `
              ${header}
              ${renderStepper(2)}
              <div class="rr-panel">
                <div class="rr-panel-title">${escapeHtml(t(i18n, 'request_details', 'REQUEST DETAILS'))}</div>
                <div class="rr-panel-sub-title">${escapeHtml(t(i18n, 'step_2_title', '2. Why would you like to return/ exchange?'))}</div>
                <div id="rrDetailBlocks"></div>

                <div style="margin-top:18px; font-weight:600;">${escapeHtml(t(i18n, 'additional_comments', '3. Additional Comments (Optional)'))}</div>
                <div class="rr-field" style="margin-top:10px;">
                  <textarea class="rr-textarea" id="rrAdditional" placeholder="${escapeHtml(t(i18n, 'additional_comments_placeholder', 'Type any additional information / request.'))}">${escapeHtml(additionalComments)}</textarea>
                </div>

                <div class="rr-actions rr-actions-submit">
                  <span class="rr-back" id="rrBack">
                    <span class="rr-back-icon" aria-hidden="true">${ICON_BACK}</span>
                    <span>${escapeHtml(t(i18n, 'return_to_edit', 'RETURN TO EDIT'))}</span>
                  </span>
                  <button class="rr-btn" id="rrSubmit" ${canSubmit() ? '' : 'disabled'} style="max-width:240px;">${escapeHtml(t(i18n, 'submit', 'SUBMIT'))}</button>
                </div>

                <div id="rrErr"></div>
              </div>
            `;

            const blocks = $('#rrDetailBlocks', el);

            blocks.innerHTML = sel.map((it) => {
              const opts = (it.options || [])
              .slice()
              .sort((a, b) => {
                const ra = String(a?.name || '').trim().toLowerCase();
                const rb = String(b?.name || '').trim().toLowerCase();

                const aIsSize = ra === 'size';
                const bIsSize = rb === 'size';
                if (aIsSize !== bIsSize) return aIsSize ? -1 : 1;

                const aIsColor = ra === 'color';
                const bIsColor = rb === 'color';
                if (aIsColor !== bIsColor) return aIsColor ? -1 : 1;

                return 0;
              })
              .map(o => {
                const rawName = String(o?.name || '').trim().toLowerCase();

                let label = o.name;
                if (rawName === 'size') {
                  label = t(i18n, 'size', 'Size');
                } else if (rawName === 'color') {
                  label = t(i18n, 'color', 'Color');
                }

                return `${label}: ${o.value}`;
              })
              .join(' | ');

              const reasonOptions =
                [`<option value="">${escapeHtml(t(i18n, 'please_select', 'Please select'))}</option>`]
                  .concat(REASONS.map(r => `<option value="${escapeHtml(r.value)}" ${it.reason === r.value ? 'selected' : ''}>${escapeHtml(r.label)}</option>`))
                  .join('');

              const policyText = getPolicyMessage(it.requestType, policyUrl, i18n);
              const showPolicy = !!it.requestType;
              const showExchange = it.requestType === 'exchange';
              const showDesc = it.reason === 'others' || it.reason === 'damaged_or_defective';
              const showAttach = it.reason === 'damaged_or_defective';

              const descLabel = it.reason === 'others'
                ? t(i18n, 'others_specify', 'Others (please specify)')
                : t(i18n, 'damage_description', 'Description of Damage/Defect');

              const descPlaceholder = it.reason === 'others'
                ? t(i18n, 'others_placeholder', 'Please specify')
                : t(i18n, 'damage_placeholder', 'Please describe the damaged/ defective product.');

              const isFileFull = validPendingCount(it) >= MAX_FILES;

              return `
                <div class="rr-item" data-line-item-id="${escapeHtml(it.lineItemId)}">
                  <div class="rr-item-head">
                    ${it.imageUrl ? `<img class="rr-thumb" src="${escapeHtml(it.imageUrl)}" alt=""/>` : `<div class="rr-thumb" aria-hidden="true"></div>`}
                    <div>
                      <div style="line-height: 20px;">${escapeHtml(it.title || '')}</div>
                      <div style="color: #777777;">${escapeHtml(opts)}</div>
                    </div>
                    <div class="rr-center">${escapeHtml(t(i18n, 'quantity', 'Quantity:'))} <span>${it.selectedQty}</span></div>
                  </div>

                  <div class="rr-item-body">
                    <div class="rr-row" style="margin-bottom:10px;">
                      <div style="width: 100%;flex: 0 0 100%;">${escapeHtml(t(i18n, 'request_type', 'Request Type'))}<span class="required-field">*</span></div>
                      <label class="rr-radio">
                        <input type="radio" name="rt_${escapeHtml(it.lineItemId)}" value="exchange" ${it.requestType === 'exchange' ? 'checked' : ''}/>
                        <span class="checkmark"></span>
                        ${escapeHtml(t(i18n, 'exchange', 'Exchange'))}
                      </label>

                      <label class="rr-radio">
                        <input type="radio" name="rt_${escapeHtml(it.lineItemId)}" value="return" ${it.requestType === 'return' ? 'checked' : ''}/>
                        <span class="checkmark"></span>
                        ${escapeHtml(t(i18n, 'refund', 'Refund'))}
                      </label>
                    </div>

                    <div class="rr-warning rr-policy" style="margin: 6px 0 12px; display:${showPolicy ? 'block' : 'none'};">
                      ${policyText}
                    </div>

                    <div class="rr-field rr-exchange-wrap" style="display:${showExchange ? 'block' : 'none'};">
                      <div>${escapeHtml(t(i18n, 'exchange_product', 'Exchange Product'))}<span class="required-field">*</span></div>
                      <textarea class="rr-textarea rr-exchange-product" placeholder="${escapeHtml(t(i18n, 'exchange_product_placeholder', 'Please specify the desired product name, color and size.'))}" style="margin-top:8px;">${escapeHtml(it.exchangeProduct || '')}</textarea>
                    </div>

                    <div class="rr-field" style="margin-top:12px;">
                      <div>${escapeHtml(t(i18n, 'reason', 'Reason'))}<span class="required-field">*</span></div>
                      <select class="rr-select rr-reason" ${it.requestType ? '' : 'disabled'}>${reasonOptions}</select>
                    </div>

                    <div class="rr-field rr-desc-wrap" style="display:${showDesc ? 'block' : 'none'}; margin-top:12px;">
                      <div class="rr-desc-label"><span class="label-text">${escapeHtml(descLabel)}</span><span class="required-field">*</span></div>
                      <textarea class="rr-textarea rr-desc" placeholder="${escapeHtml(descPlaceholder)}" style="margin-top:8px;">${escapeHtml(it.description || '')}</textarea>
                    </div>

                    <div class="rr-field rr-attach" style="display:${showAttach ? 'block' : 'none'}; margin-top:12px;">
                      <div class="rr-attach-title">${escapeHtml(t(i18n, 'attachments_title', 'Attachments (Max. 5 files)'))}<span class="required-field">*</span></div>

                      <div class="rr-upload-row">
                        <label class="rr-upload-btn ${isFileFull ? 'is-disabled' : ''}">
                          <span class="rr-ico rr-ico-upload">${ICON_UPLOAD}</span>
                          <input type="file" class="rr-file" multiple accept="image/png,image/jpeg,application/pdf" ${isFileFull ? 'disabled' : ''} />
                        </label>

                        <div class="rr-upload-hint">${escapeHtml(t(i18n, 'upload_hint', 'Click to upload images'))}
                          <ul>
                            <li>${escapeHtml(t(i18n, 'upload_format_1', 'in PNG/ JPG/ PDF format'))}</li>
                            <li>${escapeHtml(t(i18n, 'upload_format_2', 'up to 10MB per file'))}</li>
                          </ul>
                        </div>
                        <div class="rr-attachments rr-pending"></div>
                      </div>
                      <div class="rr-attachments rr-uploaded"></div>
                    </div>
                  </div>
                </div>
              `;
            }).join('');

            $$('.rr-item', blocks).forEach(card => {
              const it = findItemByLineId(card.dataset.lineItemId);
              if (it) renderFileLists(card, it);
            });

            $('#rrAdditional', el).addEventListener('input', (e) => {
              additionalComments = e.target.value;
            });

            blocks.addEventListener('change', async (e) => {
              const card = e.target.closest('.rr-item');
              if (!card) return;

              const lineItemId = card.dataset.lineItemId;
              const it = findItemByLineId(lineItemId);
              if (!it) return;

              if (e.target.matches('input[type="radio"]')) {
                it.requestType = e.target.value;

                const policyEl = $('.rr-policy', card);
                if (policyEl) {
                  const html = getPolicyMessage(it.requestType, policyUrl, i18n);
                  policyEl.innerHTML = html;
                  policyEl.style.display = it.requestType ? 'block' : 'none';
                }

                const exWrap = $('.rr-exchange-wrap', card);
                if (exWrap) exWrap.style.display = it.requestType === 'exchange' ? 'block' : 'none';

                const reasonSel = $('.rr-reason', card);
                if (reasonSel) reasonSel.disabled = !it.requestType;

                $('#rrSubmit', el).disabled = !canSubmit();
                return;
              }

              if (e.target.classList.contains('rr-reason')) {
                it.reason = e.target.value;

                const descWrap = $('.rr-desc-wrap', card);
                const labelEl = $('.rr-desc-label .label-text', card);
                const descEl = $('.rr-desc', card);

                const attach = $('.rr-attach', card);
                if (attach) attach.style.display = it.reason === 'damaged_or_defective' ? 'block' : 'none';

                const shouldShowDesc = it.reason === 'others' || it.reason === 'damaged_or_defective';
                if (descWrap) descWrap.style.display = shouldShowDesc ? 'block' : 'none';

                if (labelEl && descEl) {
                  if (it.reason === 'others') {
                    labelEl.textContent = t(i18n, 'others_specify', 'Please specify');
                    descEl.placeholder = t(i18n, 'others_placeholder', 'Please specify');
                  } else {
                    labelEl.textContent = t(i18n, 'damage_description', 'Description of Damage/Defect');
                    descEl.placeholder = t(i18n, 'damage_placeholder', 'Please describe the damaged/ defective product.');
                  }
                }

                if (!shouldShowDesc) it.description = '';

                $('#rrSubmit', el).disabled = !canSubmit();
                return;
              }

              if (e.target.classList.contains('rr-file')) {
                const inputEl = e.target;
                const files = Array.from(inputEl.files || []);
                inputEl.value = '';

                const pending = it.pendingFiles || (it.pendingFiles = []);
                let remaining = MAX_FILES - validPendingCount(it);

                if (remaining <= 0) {
                  const pendingEl = $('.rr-pending', card);
                  if (pendingEl) {
                    pendingEl.insertAdjacentHTML(
                      'beforeend',
                      `<div class="rr-warning">${escapeHtml(t(i18n, 'max_files_reached', 'You already added 5 files. Extra files will be ignored unless you remove one.'))}</div>`
                    );
                  }
                }

                for (const f of files) {
                  const err = validateFile(f);

                  if (err) {
                    pending.push({
                      id: `${Date.now()}_${Math.random().toString(16).slice(2)}`,
                      file: f,
                      name: f.name,
                      size: f.size,
                      type: f.type,
                      valid: false,
                      error: err
                    });
                    continue;
                  }

                  if (remaining <= 0) {
                    pending.push({
                      id: `${Date.now()}_${Math.random().toString(16).slice(2)}`,
                      file: f,
                      name: f.name,
                      size: f.size,
                      type: f.type,
                      valid: false,
                      error: t(i18n, 'file_ignored', 'Max 5 files. This file is ignored.')
                    });
                    continue;
                  }

                  pending.push({
                    id: `${Date.now()}_${Math.random().toString(16).slice(2)}`,
                    file: f,
                    name: f.name,
                    size: f.size,
                    type: f.type,
                    valid: true,
                    error: ''
                  });
                  remaining--;
                }

                renderFileLists(card, it);
                $('#rrSubmit', el).disabled = !canSubmit();
                return;
              }
            });

            blocks.addEventListener('input', (e) => {
              const card = e.target.closest('.rr-item');
              if (!card) return;

              const lineItemId = card.dataset.lineItemId;
              const it = findItemByLineId(lineItemId);
              if (!it) return;

              if (e.target.classList.contains('rr-desc')) it.description = e.target.value;
              if (e.target.classList.contains('rr-exchange-product')) it.exchangeProduct = e.target.value;

              $('#rrSubmit', el).disabled = !canSubmit();
            });

            blocks.addEventListener('click', (e) => {
              const btn = e.target.closest('.rr-remove-file');
              if (!btn) return;

              const card = e.target.closest('.rr-item');
              if (!card) return;

              const lineItemId = card.dataset.lineItemId;
              const it = findItemByLineId(lineItemId);
              if (!it) return;

              const id = btn.dataset.pendingId;
              it.pendingFiles = (it.pendingFiles || []).filter(p => p.id !== id);

              renderFileLists(card, it);
              $('#rrSubmit', el).disabled = !canSubmit();
            });

            $('#rrBack', el).addEventListener('click', () => {
              step = 1;
              render();
              scrollToTopSmooth();
            });

            $('#rrSubmit', el).addEventListener('click', async () => {
              const btn = $('#rrSubmit', el);
              const errEl = $('#rrErr', el);
              errEl.innerHTML = '';

              additionalComments = $('#rrAdditional', el).value;

              if (!canSubmit()) {
                errEl.innerHTML = `<div class="rr-error">${escapeHtml(t(i18n, 'required_fields_error', 'Please complete the required fields before submitting.'))}</div>`;
                return;
              }

              setBusy(btn, true, i18n);
              try {
                const sel = selectedItems();

                for (const it of sel) {
                  await uploadPendingForItem(it);
                }

                const customerLocale = getCustomerLocale();

                const payload = {
                  sessionId,
                  selectedItems: sel.map(it => ({
                    lineItemId: it.lineItemId,
                    quantity: it.selectedQty,
                    requestType: it.requestType,
                    reason: it.reason,
                    description: it.description,
                    desired: it.requestType === 'exchange'
                      ? { size: '', color: '', note: it.exchangeProduct }
                      : null,
                    attachments: it.attachments,
                    sku: it.sku,
                    title: it.title,
                  })),
                  additionalComments,
                  customerLocale
                };

                const resp = await apiFetch(apiBaseUrl, '/submit', {
                  method: 'POST',
                  body: JSON.stringify(payload),
                });

                step = 99;
                el.innerHTML = `
                  <div class="rr-center rr-center rr-center-subtitle" style="margin-bottom:10px;">
                    <div>${escapeHtml(t(i18n, 'order_number_label', 'ORDER NUMBER:'))} <span>${escapeHtml(order.orderNumber || '')}</span></div>
                  </div>
                  ${renderStepper(3)}
                  <div class="rr-submitted">
                    <div class="rr-check rr-panel-title">${ICON_STATUS_OK} ${escapeHtml(t(i18n, 'request_submitted', 'REQUEST SUBMITTED'))}</div>
                    <p style="margin-top:14px;">${escapeHtml(t(i18n, 'submitted_thank_you', 'Thank you for your return/exchange request with EVISU.'))}</p>
                    <p>${escapeHtml(t(i18n, 'submitted_review', 'We will review the details and get back to you on the return authorization result within 4 working days.'))}</p>
                    <p>${tf(t(i18n, 'submitted_email_notice_html', 'A confirmation email has been sent to <strong>{{email}}</strong>. Should you need further assistance,<br>please feel free to reply that email or contact our Customer Care Team at <a title="contact us at cs@evisu.com" href="mailto:cs@evisu.com">cs@evisu.com</a>.<br>We are always here to help!'), { email: escapeHtml(order.email || '') })}</p>
                    <div style="margin-top:18px;"><button class="rr-btn" id="rrHome" style="max-width:260px;">${escapeHtml(t(i18n, 'return_homepage', 'RETURN TO HOMEPAGE'))}</button></div>
                    <div class="rr-muted" style="margin-top:12px;display: none;">Request ID: ${escapeHtml(resp.requestId || '')}</div>
                  </div>
                `;
                scrollToTopSmooth();
                $('#rrHome', el).addEventListener('click', () => window.location.assign(homeUrl));
              } catch (err) {
                errEl.innerHTML = `<div class="rr-error">${escapeHtml(err.message || t(i18n, 'submit_failed', 'Submit failed'))}</div>`;
              } finally {
                setBusy(btn, false, i18n);
              }
            });

            return;
          }
        }

        render();
      } catch (err) {
        const msg = String(err?.message || '');
        const lower = msg.toLowerCase();

        if (lower.includes('session expired') || lower.includes('session invalid') || lower.includes('expired or invalid')) {
          el.innerHTML = `<div class="rr-error">${escapeHtml(t(i18n, 'session_expired', 'Session expired or invalid. Please verify your order again.'))}</div>`;
          setTimeout(() => window.location.assign('/pages/returns-exchanges-verify'), 3000);
          return;
        }

        el.innerHTML = `<div class="rr-error">${escapeHtml(msg || t(i18n, 'failed_load_order', 'Failed to load order.'))}</div>`;
      }
    })();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const verify = document.getElementById('RRVerifyApp');
    if (verify) mountVerify(verify);

    const request = document.getElementById('RRRequestApp');
    if (request) mountRequest(request);
  });
})();
